import {
    ScrollView,
    View,
    ActivityIndicator,
    CCText
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

import AppConfig from "../../../AppConfig";
import {useEffect, useState} from "react";
import {ThemeButton, BorderlessButton, DarkButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import {useSelector} from "react-redux";
import BottomActionBar from "../../../custom-packages/contextual-action-bar/BottomActionBar";
import Poll from "../../../models/poll/Poll";
import ChocoForm from "../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoFormTS from "../../../custom-packages/react-chocoforms/typescript/ChocoFormTS";
import ChocoControl from "../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import {useNavigate, useParams} from "react-router-dom";
import PollResponseAnswer from "../../../models/poll/PollResponseAnswer";
import {GetHoursDifference, SaveCurrentTime} from "../../../LocalStorageFunctions";

const TPublicPollScreen = {
    // English
    "enUS": {
        // FOR POLLING
        'OPTIONAL': '(OPTIONAL)',
        'POLL': 'Poll',
        'NAME': 'Name',
        'DESCRIPTION': 'Description (Optional)',
        'QUESTIONS': 'Questions',
        'CANCEL': 'Cancel',
        'SAVE': 'Send',
        'INVALID_NAME': 'Invalid poll name',
        'SAVED_SUCCESSFULLY': 'Poll answered successfully',
        'RETURN': 'Return',
    },
    // Spanish
    "esMX": {
        // FOR POLLING
        'OPTIONAL': '(OPCIONAL)',
        'POLL': 'Encuesta',
        'NAME': 'Nombre',
        'DESCRIPTION': 'Descripción (Opcional)',
        'QUESTIONS': 'Preguntas',
        'CANCEL': 'Cancelar',
        'SAVE': 'Enviar',
        'INVALID_NAME': 'Nombre de encuesta inválido',
        'SAVED_SUCCESSFULLY': 'Tus respuestas han sido enviadas, gracias por tu opinion!',
        'RETURN': 'Regresar',
    }
}

const PublicPollScreen = () => {
    // @ts-ignore
    const auth = useSelector(state => state.Auth)
    const navigate = useNavigate();
    const params = useParams()
    const pollID = params.id;

    const [loading, setLoading] = useState(true);

    const [successMsg, setSuccessMsg] = useState(false);

    const [errorMsg] = useState(null);
    const [saving, setSaving] = useState(false);
    const [poll, setPoll] = useState<Poll>(new Poll())

    const [mainForm, setMainForm] = useState<ChocoForm>(new ChocoForm())

    //const {isMobile} = useViewport();

    const save = async () => {
        setSaving(true)

        let formData = new Array<PollResponseAnswer>();

        for (let key in mainForm.controls) {
            const answer = new PollResponseAnswer();

            switch (mainForm.controls[key].elementType){
                case "score":
                    answer.pra_score = mainForm.controls[key].value
                    break;
                case "input":
                    answer.pra_answer = mainForm.controls[key].value
                    break;
            }

            answer.pra_poll_question_id = mainForm.controls[key].metaData.questionID

            formData.push(answer)
        }

        try {
            const response = await fetch('/Poll/Answer/' + poll.pol_id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const responseData = await response.json();

            if (responseData.success) {
                SaveCurrentTime(AppConfig.POLL_ANSWER_DATE_CHECK)
                setSuccessMsg(TPublicPollScreen[AppConfig.lang].SAVED_SUCCESSFULLY)
            } else {
                // Handle failure here...
            }
        } catch (error) {
            console.error('Error:', error);
        }

        setSaving(false)
    }

    const fetchData = async () => {
        setLoading(true)
        const response = await fetch('/Poll/FetchPoll/' + pollID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const responseData = await response.json();
        setPoll(responseData.poll)

        const mainFormCopy = new ChocoForm()


        // SETUP CONTROLS
        let controls = new Array<ChocoControl>();

        for(let i = 0; i < responseData.poll.questions.length; i++){
            const question = responseData.poll.questions[i];

            const questionControl = new ChocoControl();

            switch (question.pqu_type){
                case "SCORE":
                    questionControl.elementType = "score";
                    break;
                case "OPEN":
                    questionControl.elementType = "input";
                    break;
            }
            questionControl.validation.required = question.pqu_required
            questionControl.label = question.pqu_required ? question.pqu_question + "*" : question.pqu_question + " " + TPublicPollScreen[AppConfig.lang].OPTIONAL;
            questionControl.elementConfig = {
                placeholder: question.pqu_question
            };

            questionControl.metaData = {
                questionID: question.pqu_id
            }

            controls.push(questionControl)
        }

        mainFormCopy.controls = controls;
        // END SETUP CONTROLS



        setMainForm(mainFormCopy)
        setLoading(false)
    }

    useEffect(() => {
        const hours = GetHoursDifference(AppConfig.POLL_ANSWER_DATE_CHECK)

        if(hours < 4){
            setSuccessMsg(TPublicPollScreen[AppConfig.lang].SAVED_SUCCESSFULLY)
            setLoading(false)

            return
        }

        if (pollID)
            fetchData()
        else
            setLoading(false)
    }, []);

    if (loading)
        return <ActivityIndicator style={{marginTop: 50}}/>

    if(successMsg)
        return <View>
            <div style={{marginTop: 15, textAlign: 'center'}} className={'alert alert-success'}>{successMsg}</div>
            <View
                style={{
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <DarkButton
                    text={TPublicPollScreen[AppConfig.lang].RETURN}
                    onPress={() => {
                        navigate(-1)
                    }}
                />
            </View>
        </View>

    return <ScrollView>
        <View
            className={'row'}
        >
            <View
                className={'col-12'}
            >
                <h1
                    style={{marginTop: 30}}
                >
                    {poll.pol_name}
                </h1>
                <View>
                    <CCText
                        style={{
                            color: 'gray'
                        }}
                    >
                        {poll.pol_description}
                    </CCText>
                </View>
            </View>
            <View
                className={'col-12'}
            >
                <View
                    className={"card"}
                >
                    <View
                        className={"card-body"}
                    >
                        <ChocoFormTS
                            form={mainForm}
                            onFormChange={(updatedForm) => {
                                setMainForm(updatedForm)
                            }}
                        />
                    </View>
                </View>
            </View>
            <View>
                <BottomActionBar>
                    <View
                        style={{width: '100%'}}
                    >
                        {
                            errorMsg ?
                                <div style={{marginTop: 15}} className={'alert alert-danger'}>{errorMsg}</div>
                                :
                                null
                        }
                        {
                            successMsg ?
                                <div style={{marginTop: 15}} className={'alert alert-success'}>{successMsg}</div>
                                :
                                null
                        }
                        <View
                            style={{flexDirection: 'row', justifyContent: 'flex-end'}}
                        >
                            {
                                !saving ?
                                    <BorderlessButton
                                        text={TPublicPollScreen[AppConfig.lang].CANCEL}
                                        onPress={() => {
                                            navigate(-1)
                                        }}
                                    />
                                    :
                                    null
                            }
                            <View style={{ width: 7 }}></View>
                            <ThemeButton
                                disabled={!mainForm.isValidForm || saving}
                                text={
                                    saving ?
                                        <ActivityIndicator color={'white'} size={24}/>
                                        :
                                        TPublicPollScreen[AppConfig.lang].SAVE
                                }
                                onPress={save}
                            />
                        </View>
                    </View>
                </BottomActionBar>
            </View>
            <View style={{height: 200}}></View>
        </View>
    </ScrollView>
}

export default PublicPollScreen;